import React, { useEffect } from 'react';
import './home.css';

const Home = () => {
  useEffect(() => {
    const handleScroll = () => {
      const container = document.querySelector('.home-container');
      const elements = container.querySelectorAll('h1, h3');

      const rect = container.getBoundingClientRect();

      // Check if Home section is visible
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        elements.forEach((el) => {
          el.classList.add(
            el.classList.contains('slide-left')
              ? 'in-view-left'
              : 'in-view-right'
          );
        });
      } else {
        elements.forEach((el) => {
          el.classList.remove('in-view-left', 'in-view-right');
        });
      }
    };

    // Trigger the scroll handler on load
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="home-container" id="home">
      <div className="container">
        <h3>
          We are <span>Kodex Solutions</span>
        </h3>
        <h1 className="slide-left">
          digital <span>solutions</span>
        </h1>
        <h1 className="slide-right">
          built for
        </h1>
        <h1 className="slide-left">
          business <span>growth</span>
        </h1>
        <p className="home-intro">
          We help businesses in Sweden grow through modern websites, custom
          web applications and reliable digital solutions.
        </p>
        <div className="button-container">
          <div className="btn-border-light">
            <div className="btn-border-light-inner">
              <a className="home-btn home-first-btn" href="#contact">Start a project</a>
            </div>
          </div>
          <div className="btn-border-light">
            <div className="btn-border-light-inner">
              <a className="home-btn" href="#project">View our work</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
